import { IInput } from "./interface";

const Input = (props: IInput) => {
  const placeholder = props.placeholder || props.label;

  switch (props.type) {
    case "checkbox":    
      return (
        <>
          <input
            type={props.type}
            name={props.variableName}
            required={props.required}
            className="mr-2"
            id={props.variableName}
            value={props.value}
          />
          <label htmlFor={props.variableName}>
            {props.label}
            {props.required && <span className="ml-0.5 text-red-500">*</span>}
          </label>
        </>
      );
    default:
      return (
        <>
          <label className="text-body" htmlFor={props.variableName}>
            {props.label}
            {props.required && <span className="ml-0.5 text-red-500">*</span>}
          </label>
          <input
            type={props.type ?? "text"}
            name={props.variableName}
            required={props.required}
            className="input"
            id={props.variableName}
            placeholder={placeholder}
            pattern={props.pattern}
            defaultValue={props.value}
            readOnly={!!props.value}
          />
        </>
      );
  }
};

export default Input;